import { sort } from "ramda";
import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setSameHeight, setSameWidth } from "../../../lib/elementUtilities";
import { systemClass } from "../../../lib/enums";
import { Slot, SlotType } from "../../../lib/types";
import buildings from "../../../assets/images/buildings/buildings";
import { closeDialog, upgradeBuilding } from "../../../store/actions";
import BuildingDetailInfoIcon from "../../ContentPopup/Contents/Headquarters/BuildingDetailInfoIcon";

interface IProps {
  slot: Slot;
  gold: number;
  bricks: number;
  powerPoints: number;
  slotPrices: Array<{ gold: number; bricks: number; powerPoints: number; }>;
  chainBuildings: SlotType[];
  tileTypeId: number;
  selectedBuilding: number;
}

const UpgradeBuilding = ({
  slot,
  gold,
  bricks,
  powerPoints,
  slotPrices,
  chainBuildings,
  selectedBuilding
}: IProps) => {
  const buildingsRowRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setSameHeight(buildingsRowRef.current || undefined);
    setSameWidth(buildingsRowRef.current || undefined);
  }, [slot]);

  const dispatch = useDispatch();

  return (
    <section className="boxes-group">
      <span className="divider"/>
      <div className="box" style={{ overflowX: "auto" }}>
        <a href="#" onClick={() => dispatch(closeDialog())} className="dismiss">×</a>
        <div className="persons row" ref={buildingsRowRef} style={{ display: "inline-flex" }}>
          {
            Object.values(sort((b1, b2) => b1.level - b2.level, chainBuildings))
              .map((building, index) => {
                const upgradeableBuilding = slot.upgradeBuildings
                  .find(b => b.id === building.id);
                const levelTooHigh = building.level > slot.type.level + 1;
                const upgradeable = !!upgradeableBuilding
                  && upgradeableBuilding.requirementsFulfilled
                  && gold >= slotPrices[building.id].gold
                  && bricks >= slotPrices[building.id].bricks
                  && powerPoints >= slotPrices[building.id].powerPoints;
                return (
                  <>
                <div className={"col-sm-6"} style={{ width: "200px" }}>
              <span className={
                `person ${systemClass.MatchHeight} ${systemClass.MatchWidth} ${selectedBuilding === building.id
                  ? "selected" : ""}`} >
                <img
                  src={buildings[`b${building.imageId}`]}
                  width={"100px"}
                  height={"107px"}
                  alt=""
                  className="photo"
                />
                <h3 className="name">
                  {building.name}&nbsp;
                  <BuildingDetailInfoIcon
                    slotType={building}
                    selectedBuilding={building.id}
                    showSingleBuilding={true}
                  />
                </h3>
                {levelTooHigh && <p>
                  Requires:<br/>
                  {chainBuildings.find(b => b.level === building.level - 1)?.name}
                </p>}
                {!levelTooHigh && !!upgradeableBuilding?.prerequisities && <p>
                  Requires:<br/>
                  {upgradeableBuilding.prerequisities}
                </p>}
                {upgradeableBuilding && !levelTooHigh
                && !upgradeableBuilding?.requirementsDevelopmentFulfilled && <p>
                  Unlock in development
                </p>}
                {!levelTooHigh && <p>
                  <span className="white">
                    <em>{slotPrices[building.id].gold}</em>&nbsp;
                    <i className={"icon icon-xs icon-zlato gold middle"}/>
                    + <em>{slotPrices[building.id].bricks}</em>&nbsp;
                    <i className={"icon icon-xs icon-infrastrukturni-body middle"}/>
                    {!!slotPrices[building.id].powerPoints
                    && <>+<em>{slotPrices[building.id].powerPoints}</em>&nbsp;
                      <i className={"icon icon-xs icon-pozemky middle"}/></>}
                  </span><br/>
                  {building.turns} turns
                </p>}
                {upgradeableBuilding || levelTooHigh
                  ? <a
                    style={{
                      position: "absolute",
                      bottom: "28px",
                      left: "22%"
                    }}
                    href="#"
                    onClick={() => upgradeable && !levelTooHigh && dispatch(
                      upgradeBuilding(slot.id, building.id)
                    )}
                    className={`btn btn-blank 
                   ${upgradeable && !levelTooHigh ? "" : "disabled"}`}
                  >
                    Upgrade
                  </a> : <><p style={{ height: "40px" }}>&nbsp;</p>
                    <i className={"icon icon-xmd icon-zaskrtnuto positive"}/></>}
              </span>
                </div>
                {index + 1 < Object.values(chainBuildings).length
                  && <div style={{ display: "flex", alignItems: "center" }}>
                  <i className={"icon icon-sipka-dlouha-r icon-xlg-centered middle"}/>
                </div>}
                  </>
                )
              })
          }
        </div>
      </div>
      <span className="divider"/>
    </section>
  )
}

export default UpgradeBuilding;
